/* テンプレート表示コンポーネント */
import React, { useCallback, memo, useContext } from 'react';
import Text from '../molecules/Text';
import axios from '../axios';
import Moment from 'moment';
import ShelfInShelf from '../molecules/ShelfInShelf';
import Shelf from '../molecules/Shelf';
import {
  ParentShelf,
  ChildShelf,
  Content,
  GuarantorInfo,
  DesiredEcontractId,
} from '../types/Template';
import Postcode from '../molecules/Postcode';
import Telnum from '../molecules/TelInput';
import NameInput from '../molecules/NameInput';
import RadioButton from '../molecules/RadioButton';
import DeSelectRadioButton from '../molecules/DeSelectRadioButton';
import CheckBox from '../molecules/CheckBox';
import Select from '../molecules/Select';
import TextArea from '../molecules/TextArea';
import Paragraph from '../molecules/Paragraph';
import Heading from '../molecules/Heading';
import LayoutDivision from '../molecules/LayoutDivision';
import YearMonth from '../molecules/InputYearMonth';
import Link from '../molecules/Link';
import Image from '../molecules/Image';
import RowFullJustifyButton from '../molecules/RowFullJustifyButton';
import RowJustifyButton from '../molecules/RowJustifyButton';
import RowLeftButton from '../molecules/RowLeftButton';
import RowRightButton from '../molecules/RowRightButton';
import RowCenterButton from '../molecules/RowCenterButton';
import BusinessDayCalendar from '../organisms/BusinessDayCalendar';
import KeyEqualZeroDisplayHiddenCheckBox from '../molecules/returnKeyEqualZeroDisplayHiddenCheckBoxJsx';
import SkipLink from '../molecules/SkipLink';
import Label from '../molecules/Label';
import Blank from '../molecules/Blank';
import OnlineIdentification from '../molecules/OnlineIdentification';
import GuarantorNumLinkedCheckBox from '../molecules/GuarantorNumLinkedCheckBox';
import {
  fm_types,
  convert_types,
  tmp_init,
  shelf_type,
  guarantors_limit,
  bank_cd_column,
  bank_cd_tmp_column,
  account_info_janame_fm_id,
  shop_where_one_wishes_business_janame_column,
  postcode_index,
  postcode_splitter,
  link_setting,
  refinance_target_check_off,
  bank_branch_name_column,
  desired_bank_branch_name_column,
  bank_branch_cd_column,
  desired_bank_branch_cd_column,
  time_splitter,
  mp_ap_section_to_user_role,
  modernization_funds_application_category,
  reception_status,
} from '../Const';
import { convertData, removeComma, splitTime, timeZeroPadding } from '../Convert';
import { isBrowserIe } from '../BrowserJudgment';
import Password from '../molecules/Password';
import StaffReceptionActionButtons from '../organisms/StaffReceptionActionButtons';
import YearMonthInput from '../molecules/YearMonth';
import StandardCalendar from '../organisms/StandardCalendar';
import MonthPickerCalendar from '../organisms/MonthPickerCalendar';
import Jacode from '../molecules/Jacode';
import JaName from '../molecules/JaName';
import Office from '../molecules/Office';
import NameInput2 from '../molecules/NameInput2';
import GuideText from '../molecules/GuideText';
import HeadingM from '../molecules/HeadingM';
import ErrorNav from '../molecules/ErrorNav';
import TimeInput from '../molecules/TimeInput';
import IncreaseMonthsSelect from '../organisms/IncreaseMonthsSelect';
import { getTargetById, targetMovePoint } from '../Scroll';
import { FixedValuesContext } from '../context/FixedValues';
import { authErrorTimeout, hasErrorMessage } from '../Common';
import RadioDesiredEcontract from '../molecules/RadioDesiredEcontract';
import { pin_method_field_name } from '../const/RadioButton';

interface Props {
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  guarantors_num: number;
  show_error_nav: boolean;
  callApi: (function_name: string, should_loading?: boolean, show_error?: boolean) => Promise<any>;
  guarantor_info: GuarantorInfo;
  is_bank_exists?: boolean;
  is_desired_bank_exists?: boolean;
  is_ja_exists?: boolean;
  is_mypage_ja?: boolean;
  setShowErrorNav?: React.Dispatch<React.SetStateAction<boolean>>;
  fetchReception?: (url: string) => Promise<any>;
  setIsLoading?: (flag: boolean) => void;
  setIsImplementOnlineIdentification?: React.Dispatch<React.SetStateAction<boolean>>;
  requestModuleWithNewContents?: (
    function_name: string,
    new_contents: Content[],
    should_loading?: boolean,
    show_error?: boolean
  ) => Promise<any>;
  is_corporate_user?: boolean;
  is_agricultural_modernization_funds?: boolean;
}

const Reception: React.FC<Props> = ({
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  guarantors_num,
  show_error_nav,
  callApi,
  guarantor_info,
  is_bank_exists,
  is_desired_bank_exists,
  is_ja_exists,
  is_mypage_ja,
  setShowErrorNav,
  fetchReception,
  setIsLoading,
  setIsImplementOnlineIdentification,
  requestModuleWithNewContents,
  is_corporate_user,
  is_agricultural_modernization_funds,
}) => {
  // TODO sakuma 固定値はすべてこちらのContextを見るように修正する
  const { has_loan_approval } = useContext({ ...FixedValuesContext });

  /**
   * 親の棚を作成
   * Note: 棚種別は 2, 3, 4以外不要
   * @return JSX.Element[]
   */
  const createParentBlock = () => {
    // 初期表示用条件
    return parent_shelfs.map(parent_shelf => {
      switch (parent_shelf.pb_kind) {
        case shelf_type.shelf: // アコーディオン出力
          return (
            <Shelf
              key={parent_shelf.pb_id}
              label={parent_shelf.pb_display_name}
              is_open={parent_shelf.pb_open}
              handleClick={() => toggleParentShelf(parent_shelf.pb_id)}
            >
              {createChildBlock(parent_shelf.pb_id)}
            </Shelf>
          );
        case shelf_type.layout_divisiton: // レイアウト用論理棚
          return (
            <LayoutDivision key={parent_shelf.pb_id}>
              {createChildBlock(parent_shelf.pb_id)}
            </LayoutDivision>
          );
        case shelf_type.fragment: // domを出力しない棚
          return (
            <React.Fragment key={parent_shelf.pb_id}>
              {createChildBlock(parent_shelf.pb_id)}
            </React.Fragment>
          );
        default:
          return;
      }
    });
  };

  /**
   * 親棚を開閉する
   *
   * @param parent_id 親棚のid
   */
  const toggleParentShelf = (parent_id: number) => {
    setParentShelfs(prev => {
      // 対象親棚のindex取得
      const current_index = prev.findIndex(value => value.pb_id === parent_id);
      // ディープコピー
      const array = prev.slice();
      array[current_index].pb_open = !prev[current_index].pb_open;
      return array;
    });
  };

  /**
   * 子の棚を作成
   * @param parent_id 親棚のid
   * @return JSX.Element[]
   */
  const createChildBlock = (parent_id: number) => {
    return child_shelfs.map(child_shelf => {
      if (parent_id !== child_shelf.pb_id) {
        return;
      }
      switch (child_shelf.cb_kind) {
        case shelf_type.shelf: // アコーディオン出力
          return (
            <ShelfInShelf
              key={child_shelf.key}
              id={child_shelf.key}
              label={child_shelf.cb_display_name}
              is_open={child_shelf.cb_open}
              handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
            >
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </ShelfInShelf>
          );
        case shelf_type.layout_divisiton: // レイアウト用論理棚
          return (
            <LayoutDivision key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </LayoutDivision>
          );
        case shelf_type.fragment: // domを出力しない棚
          return (
            <React.Fragment key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </React.Fragment>
          );
        case shelf_type.full_justify_buttons: // ボタン左右中央寄せ
          return (
            <RowFullJustifyButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowFullJustifyButton>
          );
        case shelf_type.left_button: // ボタン左寄せ
          return (
            <RowLeftButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowLeftButton>
          );
        case shelf_type.center_button: // ボタン中央寄せ
          return (
            <RowCenterButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowCenterButton>
          );
        case shelf_type.right_button: // ボタン右寄せ
          return (
            <RowRightButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowRightButton>
          );
        case shelf_type.justify_buttons: // ボタン均等割付
          return (
            <RowJustifyButton key={child_shelf.key}>
              {createContents(child_shelf.pb_id, child_shelf.cb_id)}
            </RowJustifyButton>
          );
        case shelf_type.staff_reception_action_buttons:
          return (
            !child_shelf.block_disabled && <StaffReceptionActionButtons key={child_shelf.key} />
          );
        case shelf_type.guarantor_1: // 連帯債務者・保証人１
          if (guarantor_info.guarantor_1 && guarantors_limit.first <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_2: // 連帯債務者・保証人２
          if (guarantor_info.guarantor_2 && guarantors_limit.second <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_3: // 連帯債務者・保証人３
          if (guarantor_info.guarantor_3 && guarantors_limit.three <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_4: // 連帯債務者・保証人４
          if (guarantor_info.guarantor_4 && guarantors_limit.fourth <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_5: // 連帯債務者・保証人５
          if (guarantor_info.guarantor_5 && guarantors_limit.five <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_6: // 連帯債務者・保証人６
          if (guarantor_info.guarantor_6 && guarantors_limit.six <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_7: // 連帯債務者・保証人７
          if (guarantor_info.guarantor_7 && guarantors_limit.seven <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_8: // 連帯債務者・保証人８
          if (guarantor_info.guarantor_8 && guarantors_limit.eight <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_9: // 連帯債務者・保証人９
          if (guarantor_info.guarantor_9 && guarantors_limit.nine <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_10: // 連帯債務者・保証人１０
          if (guarantor_info.guarantor_10 && guarantors_limit.ten <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_11: // 連帯債務者・保証人１１
          if (guarantor_info.guarantor_11 && guarantors_limit.eleven <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_12: // 連帯債務者・保証人１２
          if (guarantor_info.guarantor_12 && guarantors_limit.twelve <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_13: // 連帯債務者・保証人１３
          if (guarantor_info.guarantor_13 && guarantors_limit.thirteen <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_14: // 連帯債務者・保証人１４
          if (guarantor_info.guarantor_14 && guarantors_limit.fourteen <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_15: // 連帯債務者・保証人１５
          if (guarantor_info.guarantor_15 && guarantors_limit.fifteen <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_16: // 連帯債務者・保証人１６
          if (guarantor_info.guarantor_16 && guarantors_limit.sixteen <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_17: // 連帯債務者・保証人１７
          if (guarantor_info.guarantor_17 && guarantors_limit.seventeen <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_18: // 連帯債務者・保証人１８
          if (guarantor_info.guarantor_18 && guarantors_limit.eighteen <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_19: // 連帯債務者・保証人１９
          if (guarantor_info.guarantor_19 && guarantors_limit.nineteen <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        case shelf_type.guarantor_20: // 連帯債務者・保証人２０
          if (guarantor_info.guarantor_20 && guarantors_limit.twenty <= guarantors_num) {
            return (
              <ShelfInShelf
                key={child_shelf.key}
                id={child_shelf.key}
                label={child_shelf.cb_display_name}
                is_open={child_shelf.cb_open}
                handleClick={() => toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id)}
              >
                {createContents(child_shelf.pb_id, child_shelf.cb_id)}
              </ShelfInShelf>
            );
          }
          break;
        default:
          return;
      }
    });
  };

  /**
   * 子棚を開閉する
   *
   * @param parent_id 親棚のid
   * @param child_id 子棚のid
   * @param is_open 開閉フラグ（true:開,false:閉）
   */
  const toggleChildShelf = (parent_id: number, child_id: number, is_open?: boolean) => {
    setChildShelfs(prev => {
      // 対象子棚のindex取得
      const current_index = prev.findIndex(
        value => value.pb_id === parent_id && value.cb_id === child_id
      );
      // 対象子棚の開閉状態を設定
      const cb_open = typeof is_open === 'undefined' ? !prev[current_index].cb_open : is_open;
      // ディープコピー
      const array = prev.slice();
      array[current_index].cb_open = cb_open;
      return array;
    });
  };

  /**
   * 小の棚内に表示する要素を決定
   * @param pb_id 親の棚のid
   * @param cb_id 子の棚のid
   * @return JSX.Element[]
   */
  const createContents = (pb_id: number, cb_id: number) => {
    const tmp_year: Content[] = [tmp_init];
    const tmp_sei: Content[] = [tmp_init];
    return contents.map((content, index) => {
      if (cb_id !== content.cb_id || pb_id !== content.pb_id) {
        return;
      }
      switch (content.fm_type) {
        case fm_types.text: // テキストボックス表示
        case fm_types.number: // 数字入力欄表示
        case fm_types.office_code: // 取引店コード(隠しフィールド)
        case fm_types.desired_trading_office_code: // 取引希望店コード(隠しフィールド)
          return (
            <Text
              key={content.key}
              id={content.key}
              fm_id={content.fm_id}
              css_class={content.css_class}
              label={content.fm_display_name}
              placeholder={content.placeholder}
              value={String(content.value)}
              need={content.required_mark}
              message={content.message}
              name={content.field_column_name}
              handleChange={handleChange}
              suffix={content.suffix}
              prefix={content.prefix}
              help_msg={content.help_msg}
              disabled={content.disabled}
              show={content.show}
              maxlength={content.maxlength}
              handleFocus={() =>
                handleFocus(content.fm_id, content.value, content.input_assistance)
              }
              handleBlur={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
              add_comma={content.input_assistance === convert_types.add_comma ? true : false}
              input_assistance={content.input_assistance}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
            />
          );
        case fm_types.date: // Datepicker表示
          return (
            <StandardCalendar
              key={content.key}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              message={content.message}
              value={
                content.value !== null && content.value !== ''
                  ? new Date(Moment(content.value, 'YYYY-MM-DDTHH:mm:ssZ').format('YYYY/MM/DD'))
                  : null
              }
              name={content.field_column_name}
              placeholder={content.placeholder}
              help_msg={content.help_msg}
              disabled={content.disabled}
              looks_inactive={looks_inactive}
              handleChange={(date: Date | null) => {
                handleChangeInput(date ?? '', content.fm_id);
              }}
              handleBlur={() => {
                handleBlur(
                  content.fm_id,
                  content.value !== null && content.value !== ''
                    ? Moment(content.value, 'YYYY-MM-DDTHH:mm:ssZ').format('YYYY-MM-DD')
                    : content.value,
                  content.input_assistance
                );
              }}
              readonly={content.readonly}
            />
          );
        case fm_types.business_date: // BusinessDayCalendar表示（申込人：借入希望日）
          return (
            <BusinessDayCalendar
              key={content.key}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              message={content.message}
              value={
                content.value !== null && content.value !== ''
                  ? new Date(Moment(content.value).format('YYYY/MM/DD'))
                  : null
              }
              name={content.field_column_name}
              placeholder={content.placeholder}
              help_msg={content.help_msg}
              disabled={content.disabled}
              handleChange={(date: Date) => {
                handleChangeInput(date, content.fm_id);
                // TODO wakasugi.y 日付選択時にonBlurが発生しないため、onChangeでバリデーションを実行する(Githubにissueあり)
                // https://github.com/Hacker0x01/react-datepicker/issues/2028
                validationCheck(
                  content.fm_id,
                  date !== null ? Moment(date).format('YYYY-MM-DD') : '',
                  content.input_assistance
                );
              }}
              handleBlur={() => {
                handleBlur(
                  content.fm_id,
                  content.value !== null && content.value !== ''
                    ? Moment(content.value).format('YYYY-MM-DD')
                    : content.value,
                  content.input_assistance
                );
              }}
              readonly={content.readonly}
            />
          );
        case fm_types.postcode: // 郵便番号表示
          return (
            <Postcode
              key={content.key}
              id={content.key}
              name={content.field_column_name}
              label={content.fm_display_name}
              need={content.required_mark}
              value={content.value}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              placeholder={content.placeholder}
              looks_inactive={looks_inactive}
              handleChangePostCode1={(event: React.ChangeEvent<HTMLInputElement>) => {
                handleChangePostCode(
                  event.target.value,
                  content.fm_id,
                  content.value,
                  postcode_index.first
                );
              }}
              handleChangePostCode2={(event: React.ChangeEvent<HTMLInputElement>) => {
                handleChangePostCode(
                  event.target.value,
                  content.fm_id,
                  content.value,
                  postcode_index.last
                );
              }}
              handleBlurPostcode1={() => {
                // 入力値変換
                convertInputDataPostCode(
                  content.fm_id,
                  content.value,
                  content.input_assistance,
                  postcode_index.first
                );
              }}
              handleBlurPostcode2={() => {
                // 入力値変換
                const convert_data = convertInputDataPostCode(
                  content.fm_id,
                  content.value,
                  content.input_assistance,
                  postcode_index.last
                );
                // バリデーションチェック
                validationCheck(content.fm_id, convert_data, content.input_assistance);
              }}
              handleSelectAddress={(
                field_column_name,
                address,
                kana_field_column_name,
                kana_address
              ) => {
                // 住所のセット
                setContents(prev => {
                  const array = prev.slice();
                  const index = prev.findIndex(
                    value => value.field_column_name === field_column_name
                  );
                  array[index].value = address;
                  // 入力先カラムにバリデーションエラーが出ていた場合解除する
                  handleBlur(array[index].fm_id, array[index].value, array[index].input_assistance);
                  return array;
                });
                // カナ住所のセット
                setContents(prev => {
                  const array = prev.slice();
                  const index = prev.findIndex(
                    value => value.field_column_name === kana_field_column_name
                  );
                  // 住所のフリガナのカラムがない場合は変更を加えずにそのままContent配列を返す
                  if (index === -1) return array;

                  array[index].value = kana_address;
                  // 入力先カラムにバリデーションエラーが出ていた場合解除する
                  handleBlur(array[index].fm_id, array[index].value, array[index].input_assistance);
                  return array;
                });
              }}
              readonly={content.readonly}
            />
          );
        case fm_types.telnumber: // 電話番号
          return (
            <Telnum
              key={content.key}
              label={content.fm_display_name}
              value={['', '', '']} // テストの値
              need={content.required_mark}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              readonly={content.readonly}
            />
          );
        case fm_types.sei: // 姓
          tmp_sei[index] = content;
          break;
        case fm_types.mei: // 名
          return (
            <NameInput
              key={content.key}
              first_id={content.key}
              last_id={tmp_sei[index - 1].key}
              label={tmp_sei[index - 1].fm_display_name}
              need={content.required_mark}
              first_name={content.field_column_name}
              last_name={tmp_sei[index - 1].field_column_name}
              first_placeholder={content.placeholder}
              last_placeholder={tmp_sei[index - 1].placeholder}
              first_value={content.value}
              last_value={tmp_sei[index - 1].value}
              first_maxlength={content.maxlength}
              last_maxlength={tmp_sei[index - 1].maxlength}
              handleChangeFirstName={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeInput(event.target.value, content.fm_id)
              }
              handleChangeLastName={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeInput(event.target.value, tmp_sei[index - 1].fm_id)
              }
              message={tmp_sei[index - 1].message ?? content.message}
              help_msg={content.help_msg}
              first_disabled={content.disabled}
              last_disabled={tmp_sei[index - 1].disabled}
              handleBlurFirstName={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
              handleBlurLastName={() => {
                handleBlur(
                  tmp_sei[index - 1].fm_id,
                  tmp_sei[index - 1].value,
                  tmp_sei[index - 1].input_assistance
                );
              }}
              readonly={content.readonly}
            />
          );
        case fm_types.radio: // ラジオボタン
        case fm_types.guarantor_num: // 連帯保証人・債務者の人数
        case fm_types.modernization_funds_application_category: // 借入申込希望書兼経営改善資金計画書入力の申込区分
          return (
            <RadioButton
              key={content.key}
              id={content.key}
              css_class={content.css_class}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.key} // TODO tani.t 一意になる情報としてkey値を渡す
              value={content.value}
              sources={content.sources}
              handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                content.fm_type === fm_types.modernization_funds_application_category
                  ? handleChangeInputModernizationFundsApplicationCategory(
                      event.target.value,
                      content.fm_id
                    )
                  : handleChangeInputAndValidationCheck(
                      event.target.value,
                      content.fm_id,
                      content.input_assistance
                    )
              }
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
            />
          );
        case fm_types.deselect_radio: // 選択解除可能なラジオボタン
          return (
            <DeSelectRadioButton
              key={content.key}
              id={content.key}
              css_class={content.css_class}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.key}
              value={content.value}
              sources={content.sources}
              handleClick={(event: React.MouseEvent<HTMLInputElement>) => {
                handleChangeDeSelectRadio(
                  (event.target as HTMLInputElement).value,
                  content.value,
                  content.fm_id,
                  content.input_assistance
                );
              }}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
            />
          );
        case fm_types.checkbox: //チェックボックス
          return (
            <CheckBox
              key={content.key}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.field_column_name}
              value={content.value}
              sources={content.sources}
              css_class={content.css_class}
              handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeCheck(
                  event.target.value,
                  event.target.checked,
                  content.fm_id,
                  content.value,
                  content.input_assistance
                )
              }
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
            />
          );
        case fm_types.guarantor_num_linked_checkbox: // 連帯債務者等の人数と連動用チェックボックス
          return (
            <GuarantorNumLinkedCheckBox
              key={content.key}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.field_column_name}
              value={content.value}
              sources={content.sources}
              handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeCheck(
                  event.target.value,
                  event.target.checked,
                  content.fm_id,
                  content.value,
                  content.input_assistance
                )
              }
              changeGuarantorNum={() => {
                changeGuarantorNumForGuarantorNumLinkedCheckbox(
                  content.value,
                  content.fm_id,
                  guarantors_num
                );
              }}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
              guarantors_num={guarantors_num}
            />
          );
        case fm_types.refinance_target_checkbox: //借換対象用のチェックボックス
        case fm_types.agreement_checkbox: // 個人情報の取扱いに関する同意のチェックボックス
        case fm_types.owner_collateral_provider_name_check: // 所有者(担保提供者)名チェック
        case fm_types.single_checkbox: // 単一のチェックボックス
          return (
            <KeyEqualZeroDisplayHiddenCheckBox
              key={content.key}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.field_column_name}
              value={content.value}
              sources={content.sources}
              handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeKeyEqualZeroDisplayHiddenCheckBox(
                  event.target.value,
                  event.target.checked,
                  content.fm_id,
                  content.value,
                  content.input_assistance
                )
              }
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
            />
          );
        case fm_types.select: // セレクトボックス
        case fm_types.items: // 商品選択
        case fm_types.guarantornum_select: // 連帯債務者等の人数(セレクトボックス)
        case fm_types.relevant_plan_select: // 該当計画
          return (
            <Select
              key={content.key}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.field_column_name}
              value={content.value}
              sources={content.sources}
              handleChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                handleChangeInputAndValidationCheck(
                  event.target.value,
                  content.fm_id,
                  content.input_assistance
                )
              }
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              suffix={content.suffix}
              with_empty_option={true}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
            />
          );
        case fm_types.textarea: // テキストエリア
          return (
            <TextArea
              id={content.key}
              key={content.key}
              fm_id={content.fm_id}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.field_column_name}
              value={content.value}
              handleChange={handleChange}
              placeholder={content.placeholder}
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              handleBlur={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
              maxlength={content.maxlength}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
            />
          );
        case fm_types.paragraph: // Pタグ文章
          return (
            <Paragraph
              key={content.key}
              label={content.fm_display_name}
              color={content.color}
              bold={content.bold}
              is_paragraph={true}
              looks_inactive={looks_inactive}
            />
          );
        case fm_types.paragraph2: // 囲み付き文字列
          return (
            <Heading
              key={content.key}
              label={content.fm_display_name}
              color={content.color}
              bold={content.bold}
              size="s"
            />
          );
        case fm_types.year: // 年
          tmp_year[index] = content;
          break;
        case fm_types.month: // 月
          return (
            <YearMonth
              key={content.key}
              year_id={tmp_year[index - 1].key}
              month_id={content.key}
              label={tmp_year[index - 1].fm_display_name}
              need={content.required_mark}
              year_name={tmp_year[index - 1].field_column_name}
              month_name={content.field_column_name}
              year_suffix={tmp_year[index - 1].suffix}
              month_suffix={content.suffix}
              year_placeholder={tmp_year[index - 1].placeholder}
              year={tmp_year[index - 1].value}
              month={content.value}
              year_maxlength={tmp_year[index - 1].maxlength}
              help_msg={tmp_year[index - 1].help_msg}
              year_disabled={tmp_year[index - 1].disabled}
              month_disabled={content.disabled}
              message={tmp_year[index - 1].message ?? content.message}
              handleChangeYear={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeInput(event.target.value, tmp_year[index - 1].fm_id)
              }
              handleChangeMonth={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeInput(event.target.value, content.fm_id)
              }
              handleBlurYear={() => {
                handleBlur(
                  tmp_year[index - 1].fm_id,
                  tmp_year[index - 1].value,
                  tmp_year[index - 1].input_assistance
                );
              }}
              handleBlurMonth={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
              sources={content.sources}
              readonly={content.readonly}
            />
          );
        case fm_types.link: // リンク
          return (
            <Link
              key={content.key}
              anchor={content.value}
              display_name={content.fm_display_name}
              bold={true}
            />
          );
        case fm_types.skip_link: // スキップリンク
          if (has_loan_approval) {
            return (
              <SkipLink
                key={content.key}
                display_name={content.fm_display_name}
                handleClick={handleScroll}
              />
            );
          }
          break;
        case fm_types.image: // 画像
          return <Image key={content.key} value={content.value} />;
        case fm_types.pincode: // PINコード表示
          return (
            <Password
              fm_id={content.fm_id}
              key={content.key}
              id={content.key}
              label={content.fm_display_name}
              placeholder={content.placeholder}
              value={content.value}
              need={content.required_mark}
              message={content.message}
              name={content.field_column_name}
              handleChange={handleChange}
              help_msg={content.help_msg}
              disabled={content.disabled}
              maxlength={content.maxlength}
              handleBlur={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
              visible_type="number"
              readonly={content.readonly}
            />
          );
        case fm_types.year_month: // 年ヵ月入力欄
          return (
            <YearMonthInput
              key={content.key}
              id={content.key}
              fm_id={content.fm_id}
              label={content.fm_display_name}
              placeholder={content.placeholder}
              value={content.value}
              need={content.required_mark}
              message={content.message}
              name={content.field_column_name}
              handleChange={value => {
                handleChangeYearMonthInput(value, content.fm_id);
              }}
              suffix={content.suffix}
              help_msg={content.help_msg}
              disabled={content.disabled}
              maxlength={content.maxlength}
              handleBlur={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
              input_assistance={content.input_assistance}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
            />
          );
        case fm_types.date_year_month: // 年月(カレンダー付き)
          return (
            <MonthPickerCalendar
              key={content.key}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              message={content.message}
              suffix={content.suffix}
              value={
                // NOTE 「YYYY/MM」の形式ではIE,FIREFOX,SAFARIでの動作ができない為「YYYY-MM」に変換する、実際にDBに保存される値はスラッシュ区切りとなる
                content.value !== null && content.value !== ''
                  ? new Date(content.value.replace('/', '-'))
                  : null
              }
              name={content.field_column_name}
              placeholder={content.placeholder}
              help_msg={content.help_msg}
              disabled={content.disabled}
              handleChange={(date: Date | null) => {
                const str_date = date ? Moment(date).format('YYYY/MM') : '';
                handleChangeInput(str_date, content.fm_id);
              }}
              handleBlur={() => {
                handleBlur(
                  content.fm_id,
                  content.value !== null && content.value !== ''
                    ? Moment(content.value, 'YYYY/MM').format('YYYY/MM')
                    : content.value,
                  content.input_assistance
                );
              }}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
            />
          );
        case fm_types.jacode: // JA金融機関コード
        case fm_types.desired_trading_store_jacode: // JA金融機関コード(お取引希望店舗)
          return (
            <Jacode
              key={content.key}
              id={content.key}
              fm_id={content.fm_id}
              label={content.fm_display_name}
              need={content.required_mark}
              value={content.value}
              placeholder={content.placeholder}
              handleChange={handleChangeJacode}
              handleBlur={() => {
                handleBlur(content.fm_id, content.value, content.input_assistance);
              }}
              message={content.message}
              name={content.field_column_name}
              help_msg={content.help_msg}
              disabled={content.disabled}
              jacode_disabled={is_ja_exists ?? false}
              maxlength={content.maxlength}
              looks_inactive={looks_inactive}
              handleSelectJa={(jacode, janame) => {
                // NOTE 本処理は画面描画時に必ず1回走ります。
                // 特にjanameをセット処理で、janame_fm_idでjanameのfm_idを設定する必要があります。
                // 値が正しくセットされているか、constを確認すること。

                // jacodeをセット
                setContents(prev => {
                  //「JA金融機関コード」のindex番号を取得する
                  const jacode_column_index = getIndexByColumnName(bank_cd_column, prev);
                  const bank_cd_tmp_jacode_index = getIndexByColumnName(bank_cd_tmp_column, prev);
                  // ディープコピー
                  const array = prev.slice();
                  // 「JA金融機関コード」に値を設定する
                  setValueByIndex(jacode_column_index, array, jacode);
                  setValueByIndex(bank_cd_tmp_jacode_index, array, jacode);
                  return array;
                });

                // JA名をセット
                setContents(prev => {
                  const account_info_janame_index = prev.findIndex(value =>
                    account_info_janame_fm_id.includes(value.fm_id)
                  );
                  const shop_where_one_wishes_business_janame_index = prev.findIndex(value =>
                    shop_where_one_wishes_business_janame_column.includes(value.fm_id)
                  );
                  // ディープコピー
                  const array = prev.slice();
                  //「JA名」に値を設定する
                  setValueByIndex(account_info_janame_index, array, janame);
                  setValueByIndex(shop_where_one_wishes_business_janame_index, array, janame);
                  return array;
                });

                // 取引店をセット
                setContents(prev => {
                  //「取引店」のindex番号を取得する
                  const bank_branch_name_index = getIndexByColumnName(
                    bank_branch_name_column,
                    prev
                  );
                  const desired_bank_branch_name_index = getIndexByColumnName(
                    desired_bank_branch_name_column,
                    prev
                  );
                  // ディープコピー
                  const array = prev.slice();
                  // 取引店をクリアする
                  officeValueMessageClear(bank_branch_name_index, array);
                  officeValueMessageClear(desired_bank_branch_name_index, array);
                  return array;
                });

                // 取引店コードをセット
                setContents(prev => {
                  // 「取引店コード」のindex番号を取得
                  const bank_branch_cd_index = getIndexByColumnName(bank_branch_cd_column, prev);
                  const desired_bank_branch_cd_index = getIndexByColumnName(
                    desired_bank_branch_cd_column,
                    prev
                  );
                  // ディープコピー
                  const array = prev.slice();
                  // 取引店コードをクリアする
                  setValueByIndex(bank_branch_cd_index, array, '');
                  setValueByIndex(desired_bank_branch_cd_index, array, '');
                  return array;
                });
              }}
            />
          );
        case fm_types.janame: // JA名
          return (
            <JaName
              key={content.key}
              id={content.key}
              fm_id={content.fm_id}
              label={content.fm_display_name}
              need={content.required_mark}
              value={content.value}
              placeholder={content.placeholder}
              handleChange={() => {}}
              message={content.message}
              name={content.field_column_name}
              help_msg={content.help_msg}
              disabled={content.disabled}
              maxlength={content.maxlength}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
            />
          );
        case fm_types.office: // 店舗名
        case fm_types.desired_trading_office: // 取引希望店舗名
          return (
            <Office
              fm_id={content.fm_id}
              key={content.key}
              id={content.key}
              office_cd={getOfficeCd(content.field_column_name)}
              label={content.fm_display_name}
              placeholder={content.placeholder}
              value={content.value}
              need={content.required_mark}
              message={content.message}
              name={content.field_column_name}
              handleChange={() => {}}
              help_msg={content.help_msg}
              disabled={content.disabled}
              maxlength={content.maxlength}
              handleSelectDealer={(office_cd, office_name, name) => {
                // 取引店をセット
                setContents(prev => {
                  const index = prev.findIndex(value => value.fm_id === content.fm_id);
                  const array = prev.slice(); // ディープコピー
                  array[index].value = office_name;
                  array[index].message = '';
                  return array;
                });

                // 取引店コードをセット
                setContents(prev => {
                  // 「取引店コード」のindex番号を取得
                  const bank_branch_cd_index = getIndexByColumnName(bank_branch_cd_column, prev);
                  const desired_bank_branch_cd_index = getIndexByColumnName(
                    desired_bank_branch_cd_column,
                    prev
                  );
                  // ディープコピー
                  const array = prev.slice();
                  // 「取引店コード」に値を設定
                  setValueByIndexAndColumnName(
                    bank_branch_cd_index,
                    name,
                    bank_branch_name_column,
                    array,
                    office_cd
                  );
                  setValueByIndexAndColumnName(
                    desired_bank_branch_cd_index,
                    name,
                    desired_bank_branch_name_column,
                    array,
                    office_cd
                  );
                  return array;
                });
              }}
              jacode={getJacode()} // jacodeのvalueをコンポーネントに渡す
              looks_inactive={looks_inactive}
              readonly={content.readonly}
              is_bank_exists={
                content.field_column_name === desired_bank_branch_name_column
                  ? is_desired_bank_exists
                  : is_bank_exists
              }
              is_ja_exists={is_ja_exists}
              is_mypage_ja={is_mypage_ja}
              fm_type={content.fm_type}
            />
          );
        case fm_types.name: // 名前
        case fm_types.sei_name: // 名前（左側のみ必須入力）
          return (
            <NameInput2
              key={content.key}
              id={content.key}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.field_column_name}
              placeholder={content.placeholder}
              disabled={content.disabled}
              looks_inactive={looks_inactive}
              value={content.value}
              maxlength={content.maxlength}
              message={content.message}
              help_msg={content.help_msg}
              handleChangeFirstName={value => {
                handleChangeInput(value, content.fm_id);
              }}
              handleChangeLastName={value => {
                handleChangeInput(value, content.fm_id);
              }}
              handleBlurFirstName={() => {
                // 入力値変換
                const convert_data = convertInputDataForName(
                  content.fm_id,
                  content.value,
                  content.input_assistance
                );
                // 特定の種別の場合は右側の項目にて、フォーカスアウト時に入力チェックを行わない
                if (content.fm_type === fm_types.sei_name) return;
                validationCheck(content.fm_id, convert_data, content.input_assistance);
              }}
              handleBlurLastName={() => {
                // 入力値変換
                const convert_data = convertInputDataForName(
                  content.fm_id,
                  content.value,
                  content.input_assistance
                );
                // 特定の種別の場合は左側の項目にて、フォーカスアウト時に入力チェックを行わない
                if (content.fm_type === fm_types.name) return;
                validationCheck(content.fm_id, convert_data, content.input_assistance);
              }}
              readonly={content.readonly}
            />
          );
        case fm_types.guidetext: // ガイドテキスト
          return <GuideText key={content.key} label={content.fm_display_name} />;
        case fm_types.heading_m:
          return <HeadingM key={content.key} label={content.fm_display_name} />;
        case fm_types.time:
          return (
            <TimeInput
              key={content.key}
              id={content.key}
              fm_id={content.fm_id}
              label={content.fm_display_name}
              value={content.value}
              need={content.required_mark}
              disabled={content.disabled}
              handleChange={value => {
                handleChangeInput(value, content.fm_id);
              }}
              input_assistance={content.input_assistance}
              placeholder={content.placeholder}
              help_msg={content.help_msg}
              message={content.message}
              handleBlurHour={() => {
                handleBlurHour(content.fm_id, content.value, content.input_assistance);
              }}
              handleBlurMin={() => {
                handleBlurMin(content.fm_id, content.value, content.input_assistance);
              }}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
            />
          );
        case fm_types.increase_months_select: // 特定月増額返済(増額月)
          return (
            <IncreaseMonthsSelect
              key={content.key}
              fm_id={content.fm_id}
              label={content.fm_display_name}
              need={content.required_mark}
              disabled={content.disabled}
              help_msg={content.help_msg}
              message={content.message}
              value={content.value}
              handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeCheck(
                  event.target.value,
                  event.target.checked,
                  content.fm_id,
                  content.value !== null ? content.value : [],
                  content.input_assistance
                )
              }
              looks_inactive={looks_inactive}
              readonly={content.readonly}
            />
          );
        case fm_types.guidetext_show_active: // ガイドテキスト(入力画面のみ表示)
          return looks_inactive || <GuideText key={content.key} label={content.fm_display_name} />;
        case fm_types.agreement: // 同意文表示(入力画面のみ表示)
          return (
            looks_inactive || (
              <Label key={content.key} label={content.fm_display_name} text={content.value} />
            )
          );
        case fm_types.blank: // 空白用
          return <Blank key={String(index)} />;
        case fm_types.online_identification: // オンライン本人確認
        case fm_types.online_identification_guarantor:
          return (
            <OnlineIdentification
              key={content.key}
              id={content.key}
              css_class={content.css_class}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.key}
              value={content.value}
              sources={content.sources}
              handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeInputAndValidationCheck(
                  event.target.value,
                  content.fm_id,
                  content.input_assistance
                )
              }
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
              callApi={callApi}
              show_error_nav={show_error_nav}
              module_name={content.function}
              setIsImplementOnlineIdentification={setIsImplementOnlineIdentification}
              is_agricultural_modernization_funds={is_agricultural_modernization_funds}
              is_corporate_user={is_corporate_user}
            />
          );
        case fm_types.radio_desired_econtract: // 電子契約の希望
          return (
            <RadioDesiredEcontract
              key={content.key}
              id={content.key}
              css_class={content.css_class}
              label={content.fm_display_name}
              need={content.required_mark}
              name={content.key}
              value={content.value}
              sources={content.sources}
              handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeDesiredEcontract(
                  event?.target.value,
                  content.fm_id,
                  content.input_assistance
                )
              }
              message={content.message}
              help_msg={content.help_msg}
              disabled={content.disabled}
              looks_inactive={looks_inactive}
              readonly={content.readonly}
            />
          );
        default:
          break;
      }
    });
  };

  /**
   * 申込区分の値によってテンプレートを切り替える
   *
   * @param value 項目の値
   * @return {void}
   */
  const switchTemplateByApplicationCategory = (value: string): void => {
    if (typeof fetchReception !== 'undefined') {
      const target_user_role =
        value === modernization_funds_application_category.personal
          ? mp_ap_section_to_user_role.personal
          : mp_ap_section_to_user_role.corporation;

      const reception_cd = document.getElementById('reception_cd')?.getAttribute('reception_cd');
      const reception_id = document.getElementById('reception_id')?.getAttribute('reception_id');
      typeof setIsLoading !== 'undefined' && setIsLoading(true);

      const url = new URL(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/reception/${reception_cd}/${reception_id}${location.search}`
      );
      url.searchParams.append('target_user_role', target_user_role);

      fetchReception(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/reception/${reception_cd}/${reception_id}${url.search}`
      );
    }
  };

  /**
   * 「選択解除可能なラジオボタン」の選択時
   * 選択中の値をクリックしたときに未選択の状態に戻す
   * @param value クリックした値
   * @param c_value 選択中の値
   * @param fm_id 対象項目のID
   * @param input_assistance 変換種別
   * @returns
   */
  const handleChangeDeSelectRadio = (
    value: string,
    c_value: string,
    fm_id: number,
    input_assistance: string
  ) => {
    // NOTE 選択した値と選択中の値が同じ場合は空文字を返す（選択が外れる）
    const new_value = value === c_value ? '' : value;
    return handleChangeInputAndValidationCheck(new_value, fm_id, input_assistance);
  };

  /**
   * 「電子契約の希望」のラジオボタン選択時
   * @param value 入力値
   * @param fm_id maintenance_id
   * @param input_assistance 変換種別
   */
  const handleChangeDesiredEcontract = (value: string, fm_id: number, input_assistance: string) => {
    handleChangeInputAndValidationCheck(value, fm_id, input_assistance);

    if (value === '2') {
      // 「電子契約の希望」で「希望しない」を選択時
      setContents(prev => {
        const index = prev.findIndex(
          v => v.field_column_name === pin_method_field_name[fm_id as DesiredEcontractId]
        );
        const array = prev.slice();
        array[index].value = '';
        return array;
      });
    }
  };

  /**
   * JAコードを取得する
   * @return string JAコード
   */
  const getJacode = () => {
    let value = '';
    if (typeof contents !== 'undefined') {
      contents.map((content: Content) => {
        // fm_typesが「JACODE」である要素のvalueを取得
        if (
          content.fm_type === fm_types.jacode ||
          content.fm_type === fm_types.desired_trading_store_jacode
        ) {
          value = content.value;
        }
      });
    }
    return value;
  };

  /**
   * index番号とカラム名を指定して、特定の項目に値を設定する
   * @param target_index 更新対象のindex番号
   * @param name 操作しているカラム名
   * @param target_name 更新するカラム名
   * @param content 項目の配列
   * @param value 更新する値
   */
  const setValueByIndexAndColumnName = (
    target_index: number,
    name: string,
    target_name: string,
    content: Array<Content>,
    value: string
  ): void => {
    if (target_index >= 0 && name === target_name) {
      content[target_index].value = value;
    }
  };

  /**
   * index番号を指定して、特定の項目に値を設定する
   * @param target_index 更新対象のindex番号
   * @param content 項目の配列
   * @param value 更新する値
   */
  const setValueByIndex = (target_index: number, content: Array<Content>, value: string): void => {
    if (target_index >= 0) {
      content[target_index].value = value;
    }
  };

  /**
   * 特定のカラム名のindex番号を取得する
   * @param target_index カラム名
   * @param content 項目の配列
   */
  const getIndexByColumnName = (column_name: string, content: Array<Content>): number => {
    return content.findIndex(value => value.field_column_name === column_name);
  };

  /**
   * 取引店をクリアする
   * @param target_index 更新対象のindex番号
   * @param content 項目の配列
   */
  const officeValueMessageClear = (target_index: number, content: Array<Content>): void => {
    if (target_index >= 0) {
      content[target_index].value = '';
      content[target_index].message = '';
    }
  };

  /**
   * 取引店コードを取得する
   * @param name カラム名
   * @return string 取引店コード
   */
  const getOfficeCd = (name: string) => {
    // 口座情報アコーディオンの「取引店コード」のindex番号を取得
    const bank_branch_cd_index = contents.findIndex(
      value => value.field_column_name === bank_branch_cd_column
    );

    // お取引希望店舗アコーディオンの「取引店コード」のindex番号を取得
    const desired_bank_branch_cd_index = contents.findIndex(
      value => value.field_column_name === desired_bank_branch_cd_column
    );

    if (bank_branch_cd_index >= 0 && name === bank_branch_name_column) {
      return contents[bank_branch_cd_index].value;
    }

    if (desired_bank_branch_cd_index >= 0 && name === desired_bank_branch_name_column) {
      return contents[desired_bank_branch_cd_index].value;
    }
  };

  /**
   * 各項目入力値をstateに保存する
   * 対応項目：Text, TextArea
   * Note: 実装としてはこちらがベストな方法。
   * 全コンポーネントのコールバックをこの実装に変更する。
   *
   * @param event チェンジイベント
   */
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      const fm_id = Number(event.currentTarget.dataset.fm_id);
      const max_length = event.target.maxLength;
      const event_value = event.target.value;
      setContents(prev => {
        const index = prev.findIndex(value => value.fm_id === fm_id && !value.disabled);
        const array = prev.slice(); // ディープコピー
        array[index].value = event_value;
        return array;
      });
    },
    [setContents]
  );

  /**
   * 時, 分の「時」を適切な値に変換する
   *
   * @param {number} fm_id 対象のid
   * @param {string} value 現在の値
   * @param {string} input_assistance 変換タイプ
   */
  const handleBlurHour = (fm_id: number, value: string, input_assistance: string) => {
    const hour_min = splitTime(value);

    // 時, 分の「時」の値を変換する
    const convert_hour_min = convertData(input_assistance, hour_min[0]);

    const hour =
      convert_hour_min.length === 1 ? timeZeroPadding(convert_hour_min) : convert_hour_min;
    const time =
      hour.length === 0 && hour_min[1].length === 0 ? '' : `${hour}${time_splitter}${hour_min[1]}`;
    setContents(prev => {
      const index = prev.findIndex(value => value.fm_id === fm_id);
      const array = prev.slice();
      array[index].value = time;
      return array;
    });
  };

  /**
   * 時, 分の「分」を適切な値に変換する
   *
   * @param {number} fm_id 対象のid
   * @param {string} value 現在の値
   * @param {string} input_assistance 変換タイプ
   */
  const handleBlurMin = (fm_id: number, value: string, input_assistance: string) => {
    const hour_min = splitTime(value);

    // 時, 分の「分」の値を変換する
    const convert_hour_min = convertData(input_assistance, hour_min[1]);

    const min =
      convert_hour_min.length === 1 ? timeZeroPadding(convert_hour_min) : convert_hour_min;
    const time =
      hour_min[0].length === 0 && min.length === 0 ? '' : `${hour_min[0]}${time_splitter}${min}`;
    setContents(prev => {
      const index = prev.findIndex(value => value.fm_id === fm_id);
      const array = prev.slice();
      array[index].value = time;
      return array;
    });
    validationCheck(fm_id, time, input_assistance);
  };

  /**
   * 郵便番号の変更値をstateに保存する
   * 対応項目：Postcode
   *
   * @param changed_value 変更した値
   * @param fm_id 対象のid
   * @param values 現在の値
   * @param array_index 対応するindex値
   */
  const handleChangePostCode = (
    changes_value: string,
    fm_id: number,
    values: string[],
    array_index: number
  ) => {
    // 値の変更
    values[array_index] = changes_value;
    handleChangeInput(values, fm_id);
  };

  /**
   * Jacode入力時の各項目入力値をstateに保存する
   * 対応項目：Text, TextArea
   * Note: handleChangeのクローン
   *
   * @param event チェンジイベント
   */
  const handleChangeJacode = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      const fm_id = Number(event.currentTarget.dataset.fm_id);
      const max_length = event.target.maxLength;
      const event_value = event.target.value;
      setContents(prev => {
        const index = prev.findIndex(value => value.fm_id === fm_id);
        const array = prev.slice(); // ディープコピー
        array[index].value = event_value;
        return array;
      });
    },
    [setContents]
  );

  /**
   * 各項目入力値をstateに保存する
   * 対応項目：YearMonthInput
   *
   * @param event チェンジイベント
   */
  const handleChangeYearMonthInput = useCallback(
    (value: string, fm_id: number) => {
      setContents(prev => {
        const index = prev.findIndex(value => value.fm_id === fm_id && !value.disabled);
        const array = prev.slice(); // ディープコピー
        array[index].value = value;
        return array;
      });
    },
    [setContents]
  );

  /**
   * 各項目入力値をstateに保存する
   * 対応項目：Name, Text, Number, Date, TextArea, YearMonth, Postcode
   *
   * @param event_value 入力値
   * @param name 対象のname属性
   */
  const handleChangeInput = (event_value: string | Date | string[] | boolean, fm_id: number) => {
    setContents(prev => {
      const index = prev.findIndex(value => value.fm_id === fm_id && !value.disabled);
      const array = prev.slice(); // ディープコピー
      // 対象の値を変更
      array[index].value = event_value;

      return array;
    });
  };

  /**
   * 申込区分の入力値をstateに保存し、画面テンプレートを切り替える
   * 対応項目：申込区分（MODERNIZATION_FUNDS_APPLICATION_CATEGORY）
   *
   * @param event_value 入力値
   * @param fm_id 対象のフィ―ルドマスタID
   * */
  const handleChangeInputModernizationFundsApplicationCategory = (
    event_value: string | Date | string[] | boolean,
    fm_id: number
  ) => {
    const new_contents: Content[] = []; // ディープコピー先の新しい配列

    // オブジェクトをディープコピーする
    contents.map(value => {
      const obj = Object.assign({}, value);
      // 対象の値を変更
      if (value.fm_id === fm_id && !value.disabled) {
        obj.value = event_value;
      }
      new_contents.push(obj);
    });

    setContents(new_contents);
    const target_content = new_contents.find(value => value.fm_id === fm_id);

    // 種別が申込区分の場合は一時保存処理を実行する
    const module_name = new_contents.find(content => content.fm_id === fm_id && !content.disabled)
      ?.function;
    if (module_name) {
      typeof requestModuleWithNewContents !== 'undefined' &&
        requestModuleWithNewContents(module_name, new_contents, false, show_error_nav).then(res => {
          // バリエーションエラーの場合は選択した値前の、値を保持する
          res
            ? switchTemplateByApplicationCategory(target_content?.value)
            : setContents(prev => {
                const index = prev.findIndex(value => value.fm_id === fm_id && !value.disabled);
                const array = prev.slice(); // ディープコピー
                // 対象の値を変更
                array[index].value =
                  event_value === modernization_funds_application_category.personal
                    ? modernization_funds_application_category.corporation
                    : modernization_funds_application_category.personal;

                return array;
              });
        });
    }
  };

  /**
   * 各項目入力値をstateに保存し、バリデーションチェックを行う
   * 対応項目：Radio,Select,CheckBox
   *
   * @param event_value 入力値
   * @param fm_id 対象のフィ―ルドマスタID
   * @param input_assistance 変換種別
   */
  const handleChangeInputAndValidationCheck = (
    event_value: any,
    fm_id: number,
    input_assistance: string
  ) => {
    // 各項目入力値をstateに保存
    handleChangeInput(event_value, fm_id);

    const target_content = contents.find(conetnst => conetnst.fm_id === fm_id);
    const post_value =
      target_content?.fm_type === fm_types.checkbox ||
      target_content?.fm_type === fm_types.increase_months_select ||
      target_content?.fm_type === fm_types.guarantor_num_linked_checkbox
        ? event_value.join()
        : event_value;

    // バリデーションチェック
    validationCheck(fm_id, post_value, input_assistance).then(res => {
      const content = contents.find(content => content.fm_id === fm_id && !content.disabled);
      if (
        res &&
        content?.function &&
        content?.fm_type !== fm_types.modernization_funds_application_category &&
        content?.fm_type !== fm_types.online_identification &&
        content?.fm_type !== fm_types.online_identification_guarantor
      ) {
        callApi(content?.function, false, show_error_nav);
      }
    });
  };

  /**
   * 項目のフォーカスアウト時の処理
   * @param id 項目ID
   * @param value 項目の入力値
   * @param input_assistance 項目の変換タイプ
   */
  const handleBlur = (id: number, value: string, input_assistance: string) => {
    // 入力値変換
    const convert_data = convertInputData(
      id,
      value,
      // input_assistanceがrepayment_simulationの場合、addCommaが動作するようにする
      input_assistance === link_setting.input_assistance_name.repayment_simulation_housing ||
        input_assistance === link_setting.input_assistance_name.repayment_simulation_car
        ? convert_types.add_comma
        : input_assistance
    );
    // バリデーションチェック
    validationCheck(id, convert_data, input_assistance).then(res => {
      const content = contents.find(content => content.fm_id === id && !content.disabled);
      if (res && content?.function) {
        callApi(content?.function, false, show_error_nav);
      }
    });
  };

  /**
   * 項目のフォーカスイン時の処理(カンマ除去)
   * @param fm_id フィールドマスタのid
   * @param input_value 入力値
   * @param type 項目の変換タイプ
   */
  const handleFocus = (fm_id: number, input_value: string, type: string) => {
    setContents(prev => {
      const index = prev.findIndex(value => value.fm_id === fm_id && !value.disabled);
      const array = prev.slice(); // ディープコピー
      // 数値変換適用値
      const converted_value = removeComma(String(input_value), type);
      // 対象の値を変更
      array[index].value = converted_value;
      return array;
    });
  };

  /**
   * チェックボックスの変更値をstateに保存する
   * 対応項目：Checkbox
   *
   * @param checked_value チェックした値
   * @param is_checked 現在のチェック状態
   * @param fm_id フィールドマスタのid
   * @param values 現在の値
   * @param input_assistance 変換種別
   */
  const handleChangeCheck = (
    checked_value: string,
    is_checked: boolean,
    fm_id: number,
    values: string[],
    input_assistance: string
  ) => {
    // 値の変更
    if (is_checked) {
      values.push(checked_value);
    } else {
      values = values.filter(value => value !== checked_value);
    }
    values.sort((a, b) => Number(a) - Number(b));
    handleChangeInputAndValidationCheck(values, fm_id, '');
  };

  /**
   * 連帯債務者等の人数が変更された際に、現在の値を厳選する
   * 対応項目：GuarantorNumLinkedCheckBox
   *
   * @param values 現在の値
   * @param fm_id フィールドマスタのid
   * @param guarantors_num 連帯債務者等の人数
   */
  const changeGuarantorNumForGuarantorNumLinkedCheckbox = (
    values: string[],
    fm_id: number,
    guarantors_num: number
  ) => {
    values = values.filter(value => Number(value) <= guarantors_num);
    values.sort();
    handleChangeInput(values, fm_id);
  };

  /**
   * 下記、対応項目のチェックボックスの変更値をstateに保存する
   * 対応項目：REFINANCE_TARGET_CHECKBOX、AGREEMENT_CHECKBOX、OWNER_COLLATERAL_PROVIDER_NAME_CHECK、SINGLE_CHECKBOX
   *
   * @param checked_value チェックした値
   * @param is_checked 現在のチェック状態
   * @param fm_id フィールドマスタのid
   * @param values 現在の値
   * @param input_assistance 変換種別
   */
  const handleChangeKeyEqualZeroDisplayHiddenCheckBox = (
    checked_value: string,
    is_checked: boolean,
    fm_id: number,
    values: string,
    input_assistance: string
  ) => {
    // 値の変更
    if (is_checked) {
      values = checked_value;
    } else {
      values = refinance_target_check_off;
    }
    handleChangeInputAndValidationCheck(values, fm_id, input_assistance);
  };

  /**
   * 該当の項目に対し、バリデーションチェックを実施し、結果を画面に表示する
   * @param id バリデーション対象項目ID
   * @param value バリデーション対象項目入力値
   * @param type 変換タイプ
   * @return boolean バリデーション結果
   */
  const validationCheck = async (id: number, value: string, type: string) => {
    // 入力値がnullの場合、空文字に変換
    if (value === null) {
      value = '';
    }

    // NOTE repayment_simulationはaddCommaが同時に動作するため、カンマ除去が必要
    if (
      type === convert_types.add_comma ||
      type === link_setting.input_assistance_name.repayment_simulation_housing ||
      type === link_setting.input_assistance_name.repayment_simulation_car ||
      type === convert_types.allow_minus
    ) {
      value = value.replace(/,/g, ''); // カンマ除去
    }

    try {
      const response = await axios.get(`${location.origin}${process.env.MIX_MOCK_URL}/api/check`, {
        params: { id, value },
      });
      // バリデーションエラーなし
      setContents(prev => {
        const new_contents = prev.map(value =>
          value.fm_id === id && !value.disabled
            ? {
                ...value,
                message: undefined, // メッセージを初期化する
              }
            : value
        );
        const message_flg = hasErrorMessage(new_contents);
        if (typeof setShowErrorNav !== 'undefined') {
          setShowErrorNav(message_flg);
        }
        return new_contents;
      });
      return true;
    } catch (error) {
      // バリデーションエラーあり
      if (error.response.data.statusCode === 422) {
        setContents(prev => {
          const new_contents = prev.map(value =>
            value.fm_id === id && !value.disabled
              ? {
                  ...value,
                  message: error.response.data.message, // 画面にエラーメッセージを表示する
                }
              : value
          );
          const message_flg = hasErrorMessage(new_contents);
          if (typeof setShowErrorNav !== 'undefined') {
            setShowErrorNav(message_flg);
          }
          return new_contents;
        });
      } else {
        authErrorTimeout(error.response.status);
      }
      return false;
    }
  };

  /**
   * 該当の項目に対し、文字変換を実施する
   * @param id 文字変換対象項目ID
   * @param value 変換する文字
   * @param type 変換タイプ
   */
  const convertInputData = (id: number, value: string, type: string): string => {
    const convert_data = convertData(type, value);
    setContents(prev =>
      prev.map(value =>
        value.fm_id === id && !value.disabled
          ? {
              ...value,
              value: convert_data,
            }
          : value
      )
    );
    return convert_data;
  };

  /**
   * 該当の項目に対し、文字変換を実施する(type:NAME用)
   * @param id 文字変換対象項目ID
   * @param value 変換する文字
   * @param type 変換タイプ
   */
  const convertInputDataForName = (id: number, value: string, type: string): string => {
    let convert_data = convertData(type, value);

    // NOTE 姓と名の区切りは全角スペースにするため、半角スペースから全角スペースに置換する
    convert_data = convert_data.replace(/ /, '　');

    if (convert_data === '　') {
      convert_data = '';
    }

    setContents(prev =>
      prev.map(value =>
        value.fm_id === id && !value.disabled
          ? {
              ...value,
              value: convert_data,
            }
          : value
      )
    );
    return convert_data;
  };

  /**
   * 該当の項目に対し、変換を実施する(type:Postcode用)
   * @param id 文字変換対象項目ID
   * @param value 変換する文字
   * @param type 変換タイプ
   * @param postcode_type onBlurが発火したpostcodeのインデックス番号
   */
  const convertInputDataPostCode = (
    id: number,
    value: string,
    type: string,
    postcode_type: number
  ): string => {
    //入力値を変換する
    const convert_data = convertData(type, value[postcode_type] || '');

    const postcode_convert_data: string[] = [];

    //デフォルトで現在のStateの値を格納
    postcode_convert_data.push(value[postcode_index.first]);
    postcode_convert_data.push(value[postcode_index.last] || '');

    //変換の値を格納
    if (postcode_type === postcode_index.first) {
      postcode_convert_data[postcode_index.first] = convert_data;
    } else {
      postcode_convert_data[postcode_index.last] = convert_data;
    }

    setContents(prev =>
      prev.map(value =>
        value.fm_id === id && !value.disabled
          ? {
              ...value,
              value: postcode_convert_data,
            }
          : value
      )
    );
    if (
      postcode_convert_data[postcode_index.first] === '' &&
      postcode_convert_data[postcode_index.last] === ''
    ) {
      return '';
    }

    return `${postcode_convert_data[postcode_index.first]}${postcode_splitter.hyphen}${
      postcode_convert_data[postcode_index.last]
    }`;
  };

  /**
   * 対象となるエラー項目にフォーカスインする
   *
   * @return {void}
   */
  const handleClickErrorNav = () => {
    const target_contents = contents.filter(content => content.message);
    if (target_contents.length === 0) {
      return;
    }
    // 対象の棚を開く
    setChildShelfs(prev =>
      prev.map(child_shelf =>
        // 最初の項目を持つ棚のみ開く
        target_contents[0].cb_id === child_shelf.cb_id
          ? { ...child_shelf, cb_open: true }
          : child_shelf
      )
    );
    const index = contents.findIndex(
      value => !value.disabled && value.key === target_contents[0].key
    );
    if (index > 0) {
      const { target_element, scroll_option } = getTargetById(contents, index);
      //Note：棚の開閉が完了した後に移動するようインターバルを設ける
      targetMovePoint(target_element, scroll_option);
    }
  };

  return (
    <>
      {contents.length !== 0 && createParentBlock()}
      {show_error_nav && <ErrorNav onClick={handleClickErrorNav} />}
    </>
  );
};

/**
 * 画面一番下までスクロールする
 * @return {void}
 */
const handleScroll = (): void => {
  const elm = document.documentElement;

  window.scroll(0, elm.scrollHeight - elm.clientHeight);
};

const div = document.getElementById('main');
if (div) {
  //Receptionコンポーネント専用のIE対応用クラスを付与する。
  div.classList.add(isBrowserIe() ? 'ie' : 'no-ie');
}

export default memo(Reception);
